"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import Layout from "../components/layout/Layout.vue";
import VirtualDesktopContent, {
  VirtualDesktopContentController
} from "@/components/virtual-desktop/VirtualDesktopContent.vue";
import VirtualDesktopEmpty from "@/components/virtual-desktop/body/items/VirtualDesktopEmpty.vue";
import VirtualDesktopItemBody from "@/components/virtual-desktop/body/items/VirtualDesktopItemBody.vue";
import VirtualDesktopTableBody from "@/components/virtual-desktop/body/table/VirtualDesktopTableBody.vue";
import ContentModeSwitch from "@/components/virtual-desktop/elements/ContentModeSwitch.vue";
import {
  AccountSessionMixins
} from "@/service/account-session";
import MainView from "@/components/layout/MainView.vue";
import MainGroups from "@/components/virtual-desktop/elements/MainGroups.vue";
import AdvancedSearchForm from "@/components/virtual-desktop/elements/search/AdvancedSearchFormDrawer.vue";
import HeaderToolbar from "@/components/virtual-element/elements/HeaderToolBar.vue";
import HeaderSearch from "@/components/virtual-element/elements/HeaderSearch.vue";
import {
  SearchFormController,
  UiFormAnnotations
} from "@/components/form/UiForm.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import ExportRenewedDialog from "@/views/virtualdesktopItems/components/dialog-forms/ExportRenewedDialog.vue";
import VirtualdesktopForm from "@/views/virtualdesktopItems/components/dialog-forms/VirtualdesktopForm.vue";
import VdGroupDialog from "@/views/groupItems/VdGroupDialog.vue";
import BatchOperate from "@/components/virtual-element/elements/BatchOperate.vue";
import MultiImportMembers from "@/views/shopItems/components/MultiImportMembers.vue";
import VdBindAdmin from "@/views/bindItems/VdBindAdmin.vue";
import DeleteVdDialog from "./virtualdesktopItems/components/dialog-forms/DeleteVdDialog.vue";
import MultiMoveShops from "@/views/shopItems/components/MultiMoveShops.vue";
import VdBindShop from "@/views/bindItems/VdBindShop.vue";
import BindIpByVdDialog from "@/views/virtualdesktopItems/components/dialog-forms/BindIpByVdDialog.vue";
import EditVdNameDialog from "@/views/virtualdesktopItems/components/dialog-forms/EditVdNameDialog.vue";
import ProxySettingsDialog from "@/views/virtualdesktopItems/components/dialog-forms/ProxySettingsDialog.vue";
import TransferVdDialog from "@/views/virtualdesktopItems/components/dialog-forms/TransferVdDialog.vue";
import StartupByVdDialog from "@/views/virtualdesktopItems/components/dialog-forms/StartupByVdDialog.vue";
import EnclosureDialog from "@/views/virtualdesktopItems/components/dialog-forms/EnclosureDialog.vue";
import DateFormat from "@/framework/timeformatter";
import RemoteVDDialog from "@/views/virtualdesktopItems/components/dialog-forms/RemoteVDDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { Changeteam } from "@/service/Teamchange/changeteam";
import { SessionStore } from "@/service/session";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import AuthPinLogin from "@/views/auth/components/AuthPinLogin.vue";
import AccountDevice from "@/views/auth/components/AccountDevice.vue";
import NewCreateSafeEnvDialog from "@/views/virtualdesktopItems/components/dialog-forms/NewCreateSafeEnvDialog.vue";
import ForceVDExitDialog from "@/views/virtualdesktopItems/ForceVDExitDialog.vue";
import i18n from "@/lang";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import { Debounce } from "vue-debounce-decorator";
import ProxyShareDialog from "@/views/virtualdesktopItems/components/ProxyShareDialog.vue";
export class VirtualDesktopSearch extends SearchFormController {
  constructor() {
    super(...arguments);
    this.keyword = null;
    this.name = null;
    this.address = null;
    this.group = { id: null };
    this.ebusiness = [];
    this.startTime = null;
    this.endTime = null;
    this.expiryDate = [];
    this.data_status = null;
    this.autoRenew = "ALL";
  }
  clear() {
    this.keyword = null;
    this.name = null;
    this.address = null;
    this.group = { id: null };
    this.ebusiness = [];
    this.expiryDate = [];
    this.startTime = null;
    this.endTime = null;
    this.data_status = null;
    this.autoRenew = "ALL";
  }
}
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return ["name", `${value}`];
  })
], VirtualDesktopSearch.prototype, "keyword", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      message: i18n.t("loginlogs.ip_worng"),
      trigger: "blur",
      pattern: "/^(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|[1-9])\\.(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\.(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\.(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)$/"
    }
  ])
], VirtualDesktopSearch.prototype, "address", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    if (value) {
      return ["group", value.id];
    }
    return ["group", null];
  })
], VirtualDesktopSearch.prototype, "group", 2);
__decorateClass([
  UiFormAnnotations.DefaultValue([]),
  UiFormAnnotations.Query((property, value) => {
    return ["platform", _.map(value, "id")];
  })
], VirtualDesktopSearch.prototype, "ebusiness", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return ["expiredTimeStart", value];
  })
], VirtualDesktopSearch.prototype, "startTime", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return ["expiredTimeEnd", value];
  })
], VirtualDesktopSearch.prototype, "endTime", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    if (value) {
      return ["status", value.value];
    }
    return ["status", null];
  })
], VirtualDesktopSearch.prototype, "data_status", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return ["autoRenew", value];
  })
], VirtualDesktopSearch.prototype, "autoRenew", 2);
let VirtualDesktopHome = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    //VD高级搜索对象实例
    this.virtualDesktopContentController = new VirtualDesktopContentController();
    //websocket服务实例
    this.webSocketService = WebsocketViewService;
    this.searchQuery = new VirtualDesktopSearch();
    //删除cookie
    this.del_cookie = false;
    //当前行
    this.currentRow = null;
    //提交附件列表
    this.uploadedEnclosureList = [];
    //全部团队ID
    this.all_teams = SessionStore.get("all_team_id");
    //当前团队ID
    this.now_team = SessionStore.get("now_team_id");
    //分组数
    this.group_num = 0;
    this.vd_empty_image = require("../assets/img/vd-shop-empty/vd-sub-null.png");
    // public menu_mode:string = "vd_mode"
    // changeMode(mode:string){
    //     this.menu_mode = mode;
    // }
    // itemsTool:any = {
    //   can_bind_ip:false,
    //   owner:false,
    //   free_vd:false
    // }
    //
    //
    // 批量选项组件
    this.batchOperates = new Map(
      function* () {
        yield [
          "renew",
          require("@/components/virtual-desktop/batch-operate/BatchOperateRenew.vue").default
        ];
        yield [
          "batch-edit-vd",
          require("@/components/virtual-desktop/batch-operate/BatchEditVD.vue").default
        ];
        yield [
          "batch-open-auto-renew",
          require("@/components/virtual-desktop/batch-operate/BatchOpenAutoRenew.vue").default
        ];
        yield [
          "batch-close-auto-renew",
          require("@/components/virtual-desktop/batch-operate/BatchCloseAutoRenew.vue").default
        ];
        yield [
          "batch-edit-group",
          require("@/components/virtual-desktop/batch-operate/BatchEditGroup.vue").default
        ];
        yield [
          "batch-set-admin",
          require("@/components/virtual-desktop/batch-operate/BatchSetAdmin.vue").default
        ];
        yield [
          "batch-cancel-admin",
          require("@/components/virtual-desktop/batch-operate/BatchCancelAdmin.vue").default
        ];
        yield [
          "batch-delete-vd",
          require("@/components/virtual-desktop/batch-operate/BatchDeleteVD.vue").default
        ];
      }()
    );
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.launcher.restart",
        (data) => __async(this, null, function* () {
          yield this.started(data.value);
        })
      );
      if (localStorage.getItem("vd.page") !== null) {
        let page = Number(localStorage.getItem("vd.page"));
        this.virtualDesktopContentController.query.current = page;
      }
      if (localStorage.getItem("vd.size") !== null) {
        let size = Number(localStorage.getItem("vd.size"));
        this.virtualDesktopContentController.query.size = size;
      }
      if (this.$route.query.hasOwnProperty("jumpto")) {
        if (this.$route.query.jumpto === "renew") {
          setTimeout(() => __async(this, null, function* () {
            this.virtualDesktopContentController.query.filter = {
              group: "vdgroup_system_renew"
            };
            yield this.virtualDesktopContentController.search();
          }), 800);
        }
      }
    });
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
  //切换分组
  groupChange(index, indexPath) {
    var _a;
    this.group_num = ((_a = this._main_group._controller.groups.find((item) => {
      return item.id === index;
    })) == null ? void 0 : _a.quantity) || 0;
    this.searchQuery.clear();
    this.virtualDesktopContentController.query.filter = {
      group: index
    };
    this._main_group.checkGroupMove();
    for (const [_name, _value] of this.searchQuery.query().entries()) {
      if (_value === null || _value === "" || _value === "null") {
        continue;
      }
      _.set(this.virtualDesktopContentController.query.filter, _name, _value);
    }
    localStorage.setItem("vd.page", "1");
    localStorage.setItem("vd.size", "10");
    localStorage.setItem("vd.group", index);
    if (this._vd_table_body && this._vd_table_body._tableBody) {
      this._vd_table_body._tableBody.clearSort();
    }
    this.virtualDesktopContentController.query.current = 1;
    this.virtualDesktopContentController.query.size = 10;
    this.virtualDesktopContentController.search();
  }
  //编辑VD
  editVD() {
    this._multi_import_members.open("edit_vd");
  }
  //分组管理
  editGroup(arr) {
    this._vdGroupDialog.open(arr);
  }
  //置顶
  stickToTop(data) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth.pro/v1/virtual-desktops/${data.id}/top`);
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //取消置顶
  unstickToTop(data) {
    return __async(this, null, function* () {
      try {
        yield API.delete(
          `api://base.auth.pro/v1/virtual-desktops/${data.id}/top`
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //分组管理
  editGroupItem(data) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/${data.id}/groups`
        );
        this._vdGroupDialog.open([data.id], response.data.groupIds);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //前往待续费分组
  toRenewGroup() {
    return __async(this, null, function* () {
      this.virtualDesktopContentController.query.filter = {
        group: "vdgroup_system_renew"
      };
      yield this.virtualDesktopContentController.search();
    });
  }
  //分配VD管理员
  bindAdmin(arr) {
    return __async(this, null, function* () {
      yield this._vdBindAdmin.open("multi", arr);
    });
  }
  // 删除VD
  realDeleteVD(arr) {
    return __async(this, null, function* () {
      let message_tip = `${this.$t("deletevddialog.delete_message_vds")} </br>
      ${this.$t("deletevddialog.delete_message_tip")}`;
      message_tip = `${this.$t("deletevddialog.delete_message_vds")} </br>
      ${this.$t("deletevddialog.delete_message_tip")}`;
      this.$confirm(
        message_tip,
        `${this.$t("deletevddialog.delete_message_title")}`,
        {
          type: "warning",
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("deletevddialog.confirm"),
          cancelButtonText: this.$t("deletevddialog.cancel"),
          confirmButtonClass: "btn-orange",
          roundButton: true
        }
      ).then(() => __async(this, null, function* () {
        try {
          let ids = [];
          console.log(arr);
          if (arr.length) {
            for (const item of arr) {
              ids.push(item.id);
            }
          } else {
            ids.push(arr.id);
          }
          yield API.put(`api://base.auth.pro/v1/virtual-desktops-recycle-hide`, {
            ids,
            hide: true
          });
          this.$message.success(
            this.$t("deletevddialog.delete_successful")
          );
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch(() => {
      });
    });
  }
  //释放VD
  deleteVd(arr) {
    return __async(this, null, function* () {
      let message_tip = `${this.$t("deletevddialog.delete_message_vds")} </br>
      ${this.$t("deletevddialog.delete_message_tip")}`;
      if (this.$session.type === "account") {
        message_tip = `${this.$t("deletevddialog.delete_message_vds")} </br>
      ${this.$t("deletevddialog.delete_message_tip")}
        <a href="/account?tab=OrgSetting" target="_blank">${this.$t(
          "security_opcode.click_jump_tip"
        )}</a>`;
      }
      if (this.$session.type === "user") {
        message_tip = `${this.$t("deletevddialog.delete_message_vds")} </br>
      ${this.$t("deletevddialog.delete_message_tip")}
      <a href="https://www.kuajingvs.com/help" target="_blank" >${this.$t(
          "security_opcode.how_to_check_code"
        )}</a>`;
      }
      this.$prompt(
        message_tip,
        `${this.$t("deletevddialog.delete_message_title")}`,
        {
          type: "warning",
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("deletevddialog.confirm"),
          cancelButtonText: this.$t("deletevddialog.cancel"),
          confirmButtonClass: "btn-orange",
          roundButton: true,
          inputPlaceholder: this.$t("deletevddialog.placeholder"),
          inputPattern: /\S/
        }
      ).then((value) => __async(this, null, function* () {
        try {
          let ids = [];
          for (const item of arr) {
            ids.push(item.id);
          }
          const _code = value.value;
          yield API.delete(`api://base.auth.pro/v1/virtual-desktops`, {
            data: {
              ids,
              securityCode: _code
            }
          });
          this.$message.success(
            this.$t("deletevddialog.delete_successful")
          );
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch(() => {
      });
    });
  }
  toUrge(item) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/vd-urge-to-open/${item.oldId}`);
        this.$message.success(
          this.$t("vdcontainer.urge_vd_success_tip")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //打开强制关闭弹窗
  openForceDialog(item) {
    return __async(this, null, function* () {
      yield this._forceExitDialog.open(item);
    });
  }
  //店铺迁移弹窗
  moveShop(item) {
    return __async(this, null, function* () {
      yield this._multiMoveShop.open(item);
    });
  }
  //修改名字
  changeName(item) {
    this._editVdNameDialog.open(item);
  }
  //绑定IP
  bindIP(item) {
    this._bindIpByVdDialog.open(item);
  }
  //清除多选的选项
  clearBatch() {
    this._vd_table_body.clearSelection();
  }
  //改变启动按钮状态
  started(data) {
    return __async(this, null, function* () {
      try {
        let row_data = _.find(
          this.virtualDesktopContentController.result().datas,
          {
            id: data.vd_guid
          }
        );
        console.log(row_data);
        if (row_data) {
          row_data.runtime.status = "loading";
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //改变远程VD的按钮启动状态
  started_remote(data) {
    return __async(this, null, function* () {
      try {
        let row_data = _.find(
          this.virtualDesktopContentController.result().datas,
          {
            oldId: data.vd_old_id
          }
        );
        if (row_data) {
          row_data.remote_runtime.status = "loading";
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //自配代理配置代理弹窗
  proxySetting(item) {
    return __async(this, null, function* () {
      yield this._proxySettingsDialog.open(item);
    });
  }
  //选择管理员
  chooseAdmin(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/${item.id}/admins`
        );
        let _list = _.map(
          _.filter(response.data.datas, (data) => {
            return data;
          }),
          (data) => {
            return {
              id: data.id,
              label: `${data.name} (${data.account.toString().substring(
                data.account.toString().length - 4,
                data.account.toString().length
              )})`
            };
          }
        );
        this._vdBindAdmin.open("single", [item], _list);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //清除缓存
  clearCache(item) {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/v2/dynamic-browsers`);
      let arr = response.data.data;
      let exist = false;
      for (let browserItem of arr) {
        if (item.oldId === browserItem.extra.vd_id) {
          exist = true;
          break;
        }
      }
      if (exist) {
        yield UiConfirm.warnconfirm(
          this.$t("main.has_opening_browser", {
            name
          }),
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        for (let browserItem of arr) {
          if (item.oldId === browserItem.extra.vd_id) {
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/${browserItem.id}`
            );
          }
        }
      }
      const h = this.$createElement;
      let self = this;
      this.$confirm("", this.$t("vdcontainer.hint"), {
        message: h("div", void 0, [
          h(
            "div",
            {
              class: "text-content",
              style: "overflow: hidden;text-overflow: ellipsis;"
            },
            `${this.$t("vdcontainer.do_you_want_to_delete", {
              name: item.name
            })}${this.$t("vdcontainer.all_store_cache")}`
          ),
          h(
            "el-checkbox",
            {
              class: {
                "ui-checkbox": true
              },
              key: Math.random(),
              domProps: {
                checked: self.del_cookie
              },
              on: {
                input: function(event) {
                  self.del_cookie = event;
                }
              }
            },
            `${this.$t("vdcontainer.delete_synchronized_at_the_same_time")}`
          )
        ]),
        confirmButtonText: this.$t("vdcontainer.delete"),
        cancelButtonText: this.$t("vdcontainer.cancel"),
        roundButton: true,
        type: "warning"
      }).then(() => __async(this, null, function* () {
        var _a;
        if (this.del_cookie) {
          yield API.delete(`api://base.auth/api/v8/vd-cookies/${item.oldId}`);
          this.del_cookie = false;
        }
        yield API.post(`api://base.local/websockets/main`, {
          model: "delete.vd.cache",
          vd_id: item.oldId,
          account: (_a = this.$session) == null ? void 0 : _a.account
        });
        this.$message.success(
          this.$t("vdcontainer.delete_successful")
        );
        this.refresh();
      })).catch((error) => {
        console.log(error);
        this.del_cookie = false;
        return;
      });
    });
  }
  //释放VD
  deleteVD(item) {
    let message_tip = `${this.$t("deletevddialog.delete_message_single", {
      name: item.name
    })} </br>
      ${this.$t("deletevddialog.delete_message_tip")}`;
    if (this.$session.type === "account") {
      message_tip = `${this.$t("deletevddialog.delete_message_single", {
        name: item.name
      })} </br>
        ${this.$t("deletevddialog.delete_message_tip")}
        <a href="/account?tab=OrgSetting" target="_blank">${this.$t(
        "security_opcode.click_jump_tip"
      )}</a>`;
    }
    if (this.$session.type === "user") {
      message_tip = `${this.$t("deletevddialog.delete_message_single", {
        name: item.name
      })} </br>
        ${this.$t("deletevddialog.delete_message_tip")}
        <a href="https://www.kuajingvs.com/help" target="_blank">${this.$t(
        "security_opcode.how_to_check_code"
      )}</a>`;
    }
    this.$prompt(
      message_tip,
      `${this.$t("deletevddialog.delete_message_title")}`,
      {
        type: "warning",
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t("deletevddialog.confirm"),
        cancelButtonText: this.$t("deletevddialog.cancel"),
        confirmButtonClass: "btn-orange",
        roundButton: true,
        inputPlaceholder: this.$t("deletevddialog.placeholder"),
        inputPattern: /\S/
      }
    ).then((value) => __async(this, null, function* () {
      try {
        let ids = [];
        ids.push(item.id);
        const _code = value.value;
        yield API.delete(`api://base.auth.pro/v1/virtual-desktops`, {
          data: {
            ids,
            securityCode: _code
          }
        });
        this.$message.success(
          this.$t("deletevddialog.delete_successful")
        );
        this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    })).catch(() => {
    });
  }
  //转移VD
  moveVD(item) {
    let _arr = [];
    _arr.push(item.modelResource);
    this._transferVdDialog.open(_arr);
  }
  //打开远程启动弹窗
  openRemote(item) {
    this._startupByVdDialog.open_remote(item);
  }
  //打开启动列表弹窗
  openLauncher(item) {
    return __async(this, null, function* () {
      if (item.marks.is("FLOW_OVER_RANGE")) {
        try {
          yield UiConfirm.warnconfirm(this.$t("over_flow_dialog.tips"), this.$t("over_flow_dialog.title"), {
            confirmButtonText: this.$t("over_flow_dialog.confirm"),
            showClose: false,
            customClass: "new-confirm-box"
          });
        } catch (error) {
          if (error === "cancel") {
            return;
          }
        }
      }
      this._startupByVdDialog.open(item);
    });
  }
  //远程启动
  remoteLauncher(item) {
    this._startupByVdDialog.open_remote(item.modelResource);
  }
  //设置VD为常用
  setFavorite(item) {
    return __async(this, null, function* () {
      try {
        const _tip = this.$t("vdcontainer.make_sure_that_this").toString();
        yield this.$confirm(_tip, this.$t("vdcontainer.hint").toString(), {
          confirmButtonText: this.$t("vdcontainer.determine").toString(),
          cancelButtonText: this.$t("vdcontainer.cancel").toString(),
          type: "warning"
        });
        yield API.post(`api://base.auth.pro/v1/virtual-desktops/${item.id}/used`);
        item.marks = item.marks.add("FAVORITE");
        item.refresh();
        this.$message.success(
          this.$t("vdcontainer.operation_successful")
        );
        if (this.virtualDesktopContentController.query.filter.group === "vdgroup_system_often") {
          this.refresh();
        } else {
          this._main_group.refresh();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //取消设置常用
  setUnFavorite(item) {
    return __async(this, null, function* () {
      try {
        const _tip = this.$t("vdcontainer.make_sure_that_this_off").toString();
        yield this.$confirm(_tip, this.$t("vdcontainer.hint").toString(), {
          confirmButtonText: this.$t("vdcontainer.determine").toString(),
          cancelButtonText: this.$t("vdcontainer.cancel").toString(),
          type: "warning"
        });
        yield API.delete(
          `api://base.auth.pro/v1/virtual-desktops/${item.id}/used`
        );
        item.marks.tags = item.marks.tags.filter((arr) => {
          return arr !== "FAVORITE";
        });
        item.refresh();
        this.$message.success(
          this.$t("vdcontainer.operation_successful")
        );
        if (this.virtualDesktopContentController.query.filter.group === "vdgroup_system_often") {
          this.refresh();
        } else {
          this._main_group.refresh();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //搜索参数条件
  search(search) {
    const _group = _.get(
      this.virtualDesktopContentController.query.filter,
      "group"
    );
    this.virtualDesktopContentController.query.filter = {};
    if (search instanceof SearchFormController) {
      for (const [_name, _value] of search.query().entries()) {
        _.set(this.virtualDesktopContentController.query.filter, _name, _value);
      }
      this.virtualDesktopContentController.query.current = 1;
    }
    _.set(this.virtualDesktopContentController.query.filter, "group", _group);
    this.virtualDesktopContentController.search();
  }
  //展开高级搜索
  showAdvancedSearch() {
    const _advancedSearchForm = AdvancedSearchForm.create(this.searchQuery);
    _advancedSearchForm.$on("search", this.search);
    _advancedSearchForm.show();
  }
  //创建店铺
  createShop(item) {
    return __async(this, null, function* () {
      if (item.marks.is("IS_ADMIN")) {
        this._create_shop_dialog.open(null, item.id, true);
      } else {
        this._create_shop_dialog.open(null, item.id, false);
      }
    });
  }
  //跳转开通VD
  jumptopayment() {
    return __async(this, null, function* () {
      this.$router.push({ path: "/payment", query: { style: "create" } });
    });
  }
  //导出当前列表
  exportCommand(command) {
    return __async(this, null, function* () {
      switch (command) {
        case "batch-export-renew":
          this.exportRenewed();
          break;
        case "batch-export-list":
          yield this.exportList();
          break;
      }
    });
  }
  // 弹出代理链接二维码弹窗
  proxyShare(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth.pro/v1/virtual-desktops/${item.id}/proxy-share`);
        const link = response.data.link;
        this._proxyShareDialog.open(link);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //导出当前VD列表
  exportList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/current/export/all`,
          {
            params: {
              page: this.virtualDesktopContentController.query.current,
              size: this.virtualDesktopContentController.query.size,
              search: ((obj) => {
                let str = "";
                for (const prop in obj) {
                  if (Array.isArray(
                    this.virtualDesktopContentController.query.filter[prop]
                  )) {
                    if (!this.virtualDesktopContentController.query.filter[prop].length) {
                      continue;
                    }
                    if (prop === "expiryDate") {
                      continue;
                    }
                    if (prop === "platform") {
                      let substr = `${prop}=in=(`;
                      this.virtualDesktopContentController.query.filter[prop] = this.virtualDesktopContentController.query.filter[prop].map((item) => {
                        return `${item}`;
                      });
                      substr += this.virtualDesktopContentController.query.filter[prop].join(",");
                      str += `${substr});`;
                      continue;
                    }
                    str += `${this.virtualDesktopContentController.query.filter[prop][0]}=sort=${this.virtualDesktopContentController.query.filter[prop][1]};`;
                  } else {
                    if (this.virtualDesktopContentController.query.filter[prop] === null || this.virtualDesktopContentController.query.filter[prop] === "") {
                      continue;
                    }
                    if (prop === "autoRenew" && obj[prop] === "ALL") {
                      continue;
                    }
                    if (prop === "name") {
                      str += `${prop}=like="${obj[prop]}";`;
                    } else if (prop === "expiredTimeStart") {
                      str += `${prop}>=${obj[prop]};`;
                    } else if (prop === "expiredTimeEnd") {
                      str += `${prop}<=${obj[prop]};`;
                    } else {
                      str += `${prop}==${obj[prop]};`;
                    }
                  }
                }
                return str;
              })(this.virtualDesktopContentController.query.filter)
            }
          }
        );
        fetch(response.data.url).then((response2) => response2.blob()).then((blob) => {
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = response.data.title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //绑定店铺
  editShop(item) {
    return __async(this, null, function* () {
      let _list = _.map(item.shops, (data) => {
        return { id: data.id, label: data.name };
      });
      this._vdBindShop.open(item.id, _list);
    });
  }
  //导出待续费列表
  exportRenewed() {
    this._exportRenewedDialog.open();
  }
  //分组管理弹窗
  opendialog() {
    this._vdGroupDialog.open();
  }
  //打开附件管理弹窗
  openEnclosureDialog(row) {
    return __async(this, null, function* () {
      try {
        this.currentRow = row;
        this.uploadedEnclosureList = [];
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/${row.id}/files`
        );
        if (response.data.datas) {
          for (let index = 0; index < response.data.datas.length; index++) {
            if (response.data.datas[index].id) {
              yield this.getUploadedFiles(response.data.datas[index].id);
            }
          }
        }
        this._enclosure_dialog.shopId = row.oldId;
        this._enclosure_dialog.uploadedEnclosureList = this.uploadedEnclosureList;
        this._enclosure_dialog.tableLoading = false;
        this._enclosure_dialog.open(row.oldId);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 获取附件【某个店铺】
  reloadFiles(id) {
    return __async(this, null, function* () {
      console.log("reload", id);
      if (!id) {
        this.openEnclosureDialog(this.currentRow);
      }
      this.uploadedEnclosureList = [];
      yield this.getUploadedFiles(id);
      this._enclosure_dialog.uploadedEnclosureList = this.uploadedEnclosureList;
      this._enclosure_dialog.tableLoading = false;
    });
  }
  // 已上传的附件
  getUploadedFiles(fileId) {
    return __async(this, null, function* () {
      if (!fileId) {
        return;
      }
      try {
        let response = yield API.get(`api://base.auth.pro/v1/files/${fileId}`);
        this.uploadedEnclosureList = this.uploadedEnclosureList.concat(
          response.data
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //刷新
  refresh() {
    return __async(this, null, function* () {
      yield this._main_group.refresh();
      yield this.virtualDesktopContentController.search();
    });
  }
  //切换团队
  changeTeam() {
    return __async(this, null, function* () {
      let team_id = "";
      try {
        let response = yield API.get(`api://base.auth/api/v8/users/owned_org`);
        team_id = response.data.org_guid;
      } catch (error) {
      }
      let item = _.find(this.all_teams, { team_id });
      let name2 = this.$t("headertoolbar.target_team");
      if (item !== void 0) {
        name2 = item.team_name;
      }
      try {
        let _browsers = yield API.get(`api://base.local/v2/browsers`);
        if (_browsers.data.data.length > 0) {
          yield UiConfirm.warnconfirm(
            this.$t("headertoolbar.has_opening_browser", {
              name: name2
            }),
            this.$t("headertoolbar.hint"),
            {
              confirmButtonText: this.$t("headertoolbar.confirm"),
              cancelButtonText: this.$t("headertoolbar.cancel"),
              iconClass: "el-icon-warning"
            }
          );
          yield API.delete(`api://base.local/v2/browsers`);
          yield API.delete(`api://base.local/v2/dynamic-browsers`);
          yield API.delete(`api://base.local/processes`);
        }
      } catch (error) {
      }
      yield UiConfirm.confirm(
        `${this.$t("headertoolbar.whether_to_switch", { name: name2 })}`,
        this.$t("headertoolbar.switch_team"),
        {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel")
        }
      );
      let loading = this.$loading({
        lock: true,
        fullscreen: true,
        text: this.$t(
          "headertoolbar.switching_teams_please_wait_a_moment"
        ),
        customClass: "hard-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      console.log("=========================================================");
      let _res = yield Changeteam.change(team_id, "old");
      console.log(_res);
      if (_res.type === "pin") {
        loading.close();
        yield this._auth_pin.open(_res.result, "team");
        return;
      }
      if (_res.type === "device") {
        loading.close();
        yield this._account_device.open(
          _res.result,
          "team"
        );
        return;
      }
      if (_res.type === "error") {
        loading.close();
        yield UiConfirm.confirm(
          `${_res.result}`,
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            showCancelButton: false
          }
        );
      }
      if (_res.type === "success") {
        let _session = yield API.get(`api://base.auth/api/v9/account/session`);
        const session = _session.data;
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        localStorage.removeItem("gift_show");
        new Promise((resolve, reject) => {
          setTimeout(() => {
            loading.close();
            resolve(true);
          }, 1500);
        });
        yield this.sendLog();
        yield API.post(`api://base.local/websockets/messageservice`, {
          model: "pageEvent.changeTeam.success",
          value: {
            message: "changeteam.success"
          }
        });
        yield API.post(`api://base.local/websockets/view`, {
          model: "pageEvent.changeTeam.success",
          value: {
            message: "changeteam.success"
          }
        });
        yield API.post(`api://base.local/websockets/main`, {
          model: "change.team.success",
          value: {
            message: "changeteam.success"
          }
        });
        location.reload();
      }
    });
  }
  //获取团队列表信息
  getTeamList() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/team/teamlist`);
        let all_teams_id = SessionStore.get("all_team_id");
        let now_teams_id = SessionStore.get("now_team_id");
        let item = _.find(response.data.datas, { team_choose: true });
        let all_teams = response.data.datas;
        let now_teams = item.team_id;
        if (all_teams_id !== all_teams || now_teams_id !== now_teams) {
          SessionStore.set("all_team_id", all_teams);
          SessionStore.set("now_team_id", now_teams);
          this.all_teams = all_teams;
          this.now_team = now_teams;
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  //发送日志
  sendLog() {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let version = yield API.get(`api://base.local/update/version`);
        let _version = version.data.version;
        let _session = yield API.get(
          `api://base.local/storages/session/session`
        );
        yield API.post(`api://base.auth/api/v3/client/logs`, {
          logs: [
            {
              name: "client.login",
              message: "login.success",
              datas: {
                time: {
                  time: new Date().getTime(),
                  date: new Date()
                },
                session: _session.data.value.session,
                version: _version,
                patch: _version,
                computer: {
                  graphics: device.device_info.detail.graphics,
                  os_arch: device.device_info.os_arch,
                  cpu: device.device_info.detail.cpu,
                  os: device.device_info.detail.osInfo,
                  memory: device.device_info.detail.mem,
                  network: device.device_info.detail.networkInterfaces,
                  time: {
                    date: new Date()
                  }
                }
              }
            }
          ]
        });
      } catch (error) {
        console.dir(error);
      }
    });
  }
  //打开新手引导的快速创建店铺弹窗
  openNewUserCreateShop() {
    this._create_safe_env_dialog.open();
  }
};
__decorateClass([
  Ref("header-search")
], VirtualDesktopHome.prototype, "_headerSearch", 2);
__decorateClass([
  Ref("export-renewed-dialog")
], VirtualDesktopHome.prototype, "_exportRenewedDialog", 2);
__decorateClass([
  Ref("create-shop-dialog")
], VirtualDesktopHome.prototype, "_create_shop_dialog", 2);
__decorateClass([
  Ref("vd-group-dialog")
], VirtualDesktopHome.prototype, "_vdGroupDialog", 2);
__decorateClass([
  Ref("main_group")
], VirtualDesktopHome.prototype, "_main_group", 2);
__decorateClass([
  Ref("multi-import-members")
], VirtualDesktopHome.prototype, "_multi_import_members", 2);
__decorateClass([
  Ref("vd-bind-admin")
], VirtualDesktopHome.prototype, "_vdBindAdmin", 2);
__decorateClass([
  Ref("delete-vd-dialog")
], VirtualDesktopHome.prototype, "_deleteVdDialog", 2);
__decorateClass([
  Ref("multi-move-shop")
], VirtualDesktopHome.prototype, "_multiMoveShop", 2);
__decorateClass([
  Ref("vd-bind-shop")
], VirtualDesktopHome.prototype, "_vdBindShop", 2);
__decorateClass([
  Ref("edit-vd-name-dialog")
], VirtualDesktopHome.prototype, "_editVdNameDialog", 2);
__decorateClass([
  Ref("bind-ip-by-vd-dialog")
], VirtualDesktopHome.prototype, "_bindIpByVdDialog", 2);
__decorateClass([
  Ref("proxy-settings-dialog")
], VirtualDesktopHome.prototype, "_proxySettingsDialog", 2);
__decorateClass([
  Ref("transfer-vd-dialog")
], VirtualDesktopHome.prototype, "_transferVdDialog", 2);
__decorateClass([
  Ref("startup-by-vd-dialog")
], VirtualDesktopHome.prototype, "_startupByVdDialog", 2);
__decorateClass([
  Ref("enclosure-dialog")
], VirtualDesktopHome.prototype, "_enclosure_dialog", 2);
__decorateClass([
  Ref("vd_table_body")
], VirtualDesktopHome.prototype, "_vd_table_body", 2);
__decorateClass([
  Ref("remote-vd-dialog")
], VirtualDesktopHome.prototype, "remote_vd_dialog", 2);
__decorateClass([
  Ref("auth-pin")
], VirtualDesktopHome.prototype, "_auth_pin", 2);
__decorateClass([
  Ref("account-device")
], VirtualDesktopHome.prototype, "_account_device", 2);
__decorateClass([
  Ref("force_exit_dialog")
], VirtualDesktopHome.prototype, "_forceExitDialog", 2);
__decorateClass([
  Ref("safe-dialog")
], VirtualDesktopHome.prototype, "_create_safe_env_dialog", 2);
__decorateClass([
  Ref("proxy-share-dialog")
], VirtualDesktopHome.prototype, "_proxyShareDialog", 2);
__decorateClass([
  Debounce(400)
], VirtualDesktopHome.prototype, "toUrge", 1);
VirtualDesktopHome = __decorateClass([
  Component({
    components: {
      VirtualDesktopContent,
      VirtualDesktopEmpty,
      VirtualDesktopItemBody,
      VirtualDesktopTableBody,
      ContentModeSwitch,
      Layout,
      MainGroups,
      MainView,
      HeaderToolbar,
      HeaderSearch,
      ExportRenewedDialog,
      VirtualdesktopForm,
      VdGroupDialog,
      BatchOperate,
      MultiImportMembers,
      VdBindAdmin,
      DeleteVdDialog,
      MultiMoveShops,
      VdBindShop,
      EditVdNameDialog,
      BindIpByVdDialog,
      ProxySettingsDialog,
      TransferVdDialog,
      StartupByVdDialog,
      EnclosureDialog,
      RemoteVDDialog,
      AuthPinLogin,
      AccountDevice,
      ForceVDExitDialog,
      NewCreateSafeEnvDialog,
      ProxyShareDialog
    }
  })
], VirtualDesktopHome);
export {
  VirtualDesktopHome as default
};
